<script setup lang="ts">
import type { ProductUpdate, RoadmapItem, WhatsNewLoadState } from '../../models/whatsNew.types'

import RoadmapItemCard from './RoadmapItem.vue'
import WhatsNewItem from './WhatsNewItem.vue'

import { useI18n } from '@/shared/i18n'
import { Alert, Button, Drawer, Spinner } from '@/shared/ui'

withDefaults(
  defineProps<{
    updates: ProductUpdate[]
    roadmap?: RoadmapItem[]
    myVotes?: Set<number>
    state: WhatsNewLoadState
  }>(),
  { roadmap: () => [], myVotes: () => new Set<number>() },
)
const open = defineModel<boolean>({ default: false })
const emit = defineEmits<{ retry: []; vote: [item: RoadmapItem] }>()
const { t } = useI18n()
</script>

<template>
  <Drawer
    v-model="open"
    :title="t('globalSurface.whatsNew.title')"
    size="lg"
    :close-label="t('ui.close')"
  >
    <div
      v-if="state === 'idle' || state === 'loading'"
      class="whats-new-panel__state grid min-h-48 place-content-center justify-items-center gap-md text-muted text-center"
    >
      <Spinner>{{ t('globalSurface.whatsNew.loading') }}</Spinner>
    </div>
    <div
      v-else-if="state === 'error'"
      class="whats-new-panel__state grid min-h-48 place-content-center justify-items-center gap-md text-muted text-center"
    >
      <Alert tone="danger">{{ t('globalSurface.whatsNew.error') }}</Alert>
      <Button variant="outline" @click="emit('retry')">
        {{ t('globalSurface.whatsNew.retry') }}
      </Button>
    </div>
    <div
      v-else-if="state === 'empty'"
      class="whats-new-panel__state grid min-h-48 place-content-center justify-items-center gap-md text-muted text-center"
    >
      <p>{{ t('globalSurface.whatsNew.empty') }}</p>
    </div>
    <div v-else class="whats-new-panel__list grid gap-lg py-lg">
      <section v-if="updates.length > 0" aria-labelledby="whats-new-updates-heading">
        <h3 id="whats-new-updates-heading" class="m-0 mb-md text-base font-semibold">
          {{ t('globalSurface.whatsNew.updates') }}
        </h3>
        <div class="grid gap-sm">
          <WhatsNewItem v-for="item in updates" :key="item.id" :item="item" />
        </div>
      </section>

      <section v-if="roadmap.length > 0" aria-labelledby="whats-new-roadmap-heading">
        <h3 id="whats-new-roadmap-heading" class="m-0 mb-md text-base font-semibold">
          {{ t('globalSurface.whatsNew.roadmap') }}
        </h3>
        <div class="grid gap-sm">
          <RoadmapItemCard
            v-for="item in roadmap"
            :key="item.id"
            :item="item"
            :voted="myVotes.has(item.id)"
            @vote="emit('vote', item)"
          />
        </div>
      </section>
    </div>
  </Drawer>
</template>
